// extracted by mini-css-extract-plugin
export default {"buildButton":"lHA1Al"};